<div class="flex flex-col px-4 py-4 rounded-b-xl gap-4 bg-white overflow-x-hidden">
  <h1 class="text-2xl leading-snug">Zusammenfassung</h1>
  <div class="flex flex-col gap-2">
    <h3 class="font-medium text-xl">{{ progressService.selectedFestival()?.title_public }}</h3>
    <div class="w-full flex justify-between gap-2 items-start">
      <div class="flex flex-col gap-4">
        <app-progress-info [divider]="false"></app-progress-info>
        <div class="flex flex-col">
          @if(progressService.selectedPackage()) {
            <h4>Inklusive Paket "{{ progressService.selectedPackage()?.name_public }}" pro Person:</h4>
            <ul>
              @for (product of progressService.selectedPackage()?.products; track product.id) {
                <li>{{ product.pivot!.amount }}x {{ product.name_public }}</li>
              }
            </ul>
          } @else {
            <h4 class="fonz-semibold">Mindestverzehr pro Person:</h4>
            <ul>
              @for (product of selectedDaySlot()?.products; track product.id) {
                <li>{{ product.pivot!.amount }} {{ product.name_public }}</li>
              }
            </ul>
          }
        </div>
      </div>
      <span>{{ basePriceSum() | currency:'EUR' }}</span>
    </div>
  </div>
  @if (bookedProducts().length > 0) {
    <div class="flex flex-col gap-2">
      <h3 class="font-medium text-xl">Zusätzliche Produkte</h3>
        <div class="flex flex-col">
          @for (product of bookedProducts(); track product.id) {
            <div class="w-full flex justify-between">
              <span>
        {{ product.pivot!.amount }} {{ product.name_public }}
      </span>
              <span>{{ product.pivot!.amount * (+(product.price) + +(product.bediengeld || 0)) | currency:'EUR' }}</span>
            </div>
          }
        </div>
    </div>
  }
  <div class="flex flex-col gap-2">
    <h3 class="font-medium text-xl">Lieferung</h3>
    <div class="w-full flex justify-between">
      <span>{{ progressService.selectedShipping()?.buttonText }}</span>
      <span>{{ (progressService.selectedShipping()?.price || 0) | currency:'EUR' }}</span>
    </div>
  </div>
  <div class="w-full flex justify-between">
    <span class="text-xl">Gesamt</span>
    <span>{{ grandTotal() | currency:'EUR' }}</span>
  </div>
</div>
<div class="flex flex-col my-4 gap-4 px-4">
  <div class="flex flex-col gap-2" #pickupTimeElem>
    <h2 class="text-2xl leading-snug">Ankunftszeit</h2>
    <p [class.text-benzRed-700]="!acceptTermsAndConditions && triedToSubmit">Bitte geben Sie Ihre Ankunfszeit an.</p>
    <select [(ngModel)]="pickupTime" class="bg-white border-[1px] border-benzGrey-900 invalid:font-light invalid:text-benzGrey-600 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3"
            required>
      <option selected disabled hidden value="">Bitte wählen...</option>
      @for (arrivalOption of arrivalOptions(); track $index) {
        <option value="{{arrivalOption | date:'HH:mm'}}" class="text-benzGrey-900">{{arrivalOption | date:'HH:mm' }} Uhr</option>
      }
    </select>
    <p class="text-sm">Ihre Reservierung wird nur 45 Minuten lang gehalten.</p>
  </div>
  <div class="flex flex-col gap-2 pb-4 border-benzGrey-200">
    <h2 class="text-2xl leading-snug">Rechnungsinformationen</h2>
    <p>Füllen Sie Ihre Rechnungsadresse aus.</p>
    <form [formGroup]="invoiceForm" class="flex flex-col gap-2">
      <app-inputerrors [control]="invoiceForm.controls.customer_type">
        <label class="flex flex-col gap-1">
          Sie sind
          <select
            [class.border-benzRed-700]="invoiceForm.controls.customer_type.touched && !invoiceForm.controls.customer_type.valid"
            formControlName="customer_type"
            class="bg-white border-[1px] border-benzGrey-900 placeholder:font-light invalid:font-light invalid:text-benzGrey-600 placeholder:text-benzGrey-600 rounded-lg px-2 py-3" required>
            <option disabled selected hidden value="">Bitte wählen...</option>
            <option value="person">Person</option>
            <option value="company">Firma</option>
            <option value="club">Verein</option>
            <option value="other">Sonstiges</option>
          </select>
        </label>
      </app-inputerrors>
      <label class="flex flex-col gap-1">
        Kundennummer
        <input type="text" formControlName="customer_nr_old" placeholder="Optional"
               class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
      </label>
      @if (invoiceForm.controls.customer_type.valid && invoiceForm.controls.customer_type.value !== "person") {
        <app-inputerrors [control]="invoiceForm.controls.typename">
          <label class="flex flex-col gap-1">
            Firma / Verein / Sonstiges
            <input formControlName="typename"
                   [class.border-benzRed-700]="invoiceForm.controls.typename.touched && !invoiceForm.controls.typename.valid"
                   type="text" placeholder="Firma"
                   class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
          </label></app-inputerrors>
      }
      <app-inputerrors [control]="invoiceForm.controls.salutation">
        <label class="flex flex-col gap-1">
          Anrede
          <select formControlName="salutation"
                  [class.border-benzRed-700]="invoiceForm.controls.salutation.touched && !invoiceForm.controls.salutation.valid"
                  class="bg-white border-[1px] border-benzGrey-900 invalid:font-light invalid:text-benzGrey-600 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
            <option value="none">Keine Angabe</option>
            <option value="mrs">Frau</option>
            <option value="mr">Herr</option>
            <option value="other">Divers</option>
          </select>
        </label></app-inputerrors>
      <app-inputerrors [control]="invoiceForm.controls.name">
        <label class="flex flex-col gap-1">
          Vorname
          <input formControlName="name"
                 [class.border-benzRed-700]="invoiceForm.controls.name.touched && !invoiceForm.controls.name.valid"
                 type="text" placeholder="Vorname"
                 class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
        </label></app-inputerrors>
      <app-inputerrors [control]="invoiceForm.controls.surname">
        <label class="flex flex-col gap-1">
          Nachname
          <input formControlName="surname"
                 [class.border-benzRed-700]="invoiceForm.controls.surname.touched && !invoiceForm.controls.surname.valid"
                 type="text" placeholder="Nachname"
                 class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
        </label></app-inputerrors>
      <app-inputerrors [control]="invoiceForm.controls.street_extra">
        <label class="flex flex-col gap-1">
          Adresszusatz
          <input formControlName="street_extra"
                 [class.border-benzRed-700]="invoiceForm.controls.street_extra.touched && !invoiceForm.controls.street_extra.valid"
                 type="text" placeholder="Adresszusatz"
                 class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
        </label>
      </app-inputerrors>
      <app-inputerrors [control]="invoiceForm.controls.street">
        <label class="flex flex-col gap-1">
          Straße
          <input formControlName="street"
                 [class.border-benzRed-700]="invoiceForm.controls.street.touched && !invoiceForm.controls.street.valid"
                 type="text" placeholder="Straße"
                 class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
        </label></app-inputerrors>
      <app-inputerrors [control]="invoiceForm.controls.street_nr">
        <label class="flex flex-col gap-1">
          Hausnummer
          <input formControlName="street_nr"
                 [class.border-benzRed-700]="invoiceForm.controls.street_nr.touched && !invoiceForm.controls.street_nr.valid"
                 type="text" placeholder="Nr"
                 class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
        </label>
      </app-inputerrors>
      <app-inputerrors [control]="invoiceForm.controls.zipcode">
        <label class="flex flex-col gap-1">
          Postleitzahl
          <input formControlName="zipcode"
                 [class.border-benzRed-700]="invoiceForm.controls.zipcode.touched && !invoiceForm.controls.zipcode.valid"
                 type="text" pattern="[0-9]+" placeholder="PLZ"
                 class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
        </label></app-inputerrors>
      <app-inputerrors [control]="invoiceForm.controls.city">
        <label class="flex flex-col gap-1">
          Ort
          <input formControlName="city"
                 [class.border-benzRed-700]="invoiceForm.controls.city.touched && !invoiceForm.controls.city.valid"
                 type="text" placeholder="Ort"
                 class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
        </label></app-inputerrors>
      <app-inputerrors [control]="invoiceForm.controls.country">
        <label class="flex flex-col gap-1">
          Land
          <select formControlName="country" required
                  [class.border-benzRed-700]="invoiceForm.controls.country.touched && !invoiceForm.controls.country.valid"
                  class="bg-white border-[1px] border-benzGrey-900 invalid:font-light invalid:text-benzGrey-600 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
            <option disabled selected hidden="" value="">Bitte wählen...</option>
            @for (country of countries; track country.code) {
              <option [value]="country.code">{{ country.name }}</option>
            }
          </select>
        </label></app-inputerrors>
      <app-inputerrors [control]="invoiceForm.controls.email">
        <label class="flex flex-col gap-1">
          E-Mail-Adresse
          <input type="email" formControlName="email"
                 [class.border-benzRed-700]="invoiceForm.controls.email.touched && !invoiceForm.controls.email.valid"
                 placeholder="E-Mail"
                 class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
        </label></app-inputerrors>
      <app-inputerrors [control]="invoiceForm.controls.phone">
        <label class="flex flex-col gap-1">
          Telefon
          <input formControlName="phone"
                 [class.border-benzRed-700]="invoiceForm.controls.phone.touched && !invoiceForm.controls.phone.valid"
                 type="text" placeholder="Telefon"
                 class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
        </label></app-inputerrors>
      <app-inputerrors [control]="invoiceForm.controls.mobile">
        <label class="flex flex-col gap-1">
          Handynummer
          <input formControlName="mobile"
                 [class.border-benzRed-700]="invoiceForm.controls.mobile.touched && !invoiceForm.controls.mobile.valid"
                 type="text" placeholder="Handynummer"
                 class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
        </label></app-inputerrors>
    </form>
  </div>
  <div class="flex flex-col gap-2 pb-4 border-b-[1px] border-benzGrey-200">
    @if (progressService.selectedShipping()?.requiresCountryCodeInDeliveryAdress !== false) {
      <h2 class="text-2xl leading-snug">Lieferadresse</h2>
      <label class="flex gap-2">
        <input type="checkbox" [(ngModel)]="deliveryAdressEqualsInvoiceAdress"
               class="border-[1px] border-benzGrey-900 scale-150 ml-1 accent-benzRed-700">
        Lieferadresse identisch mit genannter Rechnungsadresse
      </label>
      @if (!deliveryAdressEqualsInvoiceAdress) {
        <form [formGroup]="deviatingDeliveryAdressForm" class="flex flex-col gap-2">


          <app-inputerrors [control]="deviatingDeliveryAdressForm.controls.typename">
            <label class="flex flex-col gap-1">
              Firma / Verein / Sonstiges
              <input formControlName="typename"
                     [class.border-benzRed-700]="deviatingDeliveryAdressForm.controls.typename.touched && !deviatingDeliveryAdressForm.controls.typename.valid"
                     type="text" placeholder="Firma"
                     class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
            </label></app-inputerrors>
          <app-inputerrors [control]="deviatingDeliveryAdressForm.controls.salutation">
            <label class="flex flex-col gap-1">
              Anrede
              <select formControlName="salutation"
                      [class.border-benzRed-700]="deviatingDeliveryAdressForm.controls.salutation.touched && !deviatingDeliveryAdressForm.controls.salutation.valid"
                      class="bg-white border-[1px] border-benzGrey-900 invalid:font-light invalid:text-benzGrey-600 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
                <option value="none">Keine Angabe</option>
                <option value="mrs">Frau</option>
                <option value="mr">Herr</option>
                <option value="other">Divers</option>
              </select>
            </label></app-inputerrors>

          <app-inputerrors [control]="deviatingDeliveryAdressForm.controls.name">
            <label class="flex flex-col gap-1">
              Vorname
              <input formControlName="name"
                     [class.border-benzRed-700]="deviatingDeliveryAdressForm.controls.name.touched && !deviatingDeliveryAdressForm.controls.name.valid"
                     type="text" placeholder="Vorname"
                     class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
            </label></app-inputerrors>
          <app-inputerrors [control]="deviatingDeliveryAdressForm.controls.surname">
            <label class="flex flex-col gap-1">
              Nachname
              <input formControlName="surname"
                     [class.border-benzRed-700]="deviatingDeliveryAdressForm.controls.surname.touched && !deviatingDeliveryAdressForm.controls.surname.valid"
                     type="text" placeholder="Nachname"
                     class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
            </label></app-inputerrors>
          <app-inputerrors [control]="deviatingDeliveryAdressForm.controls.street_extra">
            <label class="flex flex-col gap-1">
              Adresszusatz
              <input formControlName="street_extra"
                     [class.border-benzRed-700]="deviatingDeliveryAdressForm.controls.street_extra.touched && !deviatingDeliveryAdressForm.controls.street_extra.valid"
                     type="text" placeholder="Adresszusatz"
                     class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
            </label>
          </app-inputerrors>
          <app-inputerrors [control]="deviatingDeliveryAdressForm.controls.street">
            <label class="flex flex-col gap-1">
              Straße
              <input formControlName="street"
                     [class.border-benzRed-700]="deviatingDeliveryAdressForm.controls.street.touched && !deviatingDeliveryAdressForm.controls.street.valid"
                     type="text" placeholder="Straße"
                     class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
            </label></app-inputerrors>
          <app-inputerrors [control]="deviatingDeliveryAdressForm.controls.street_nr">
            <label class="flex flex-col gap-1">
              Hausnummer
              <input formControlName="street_nr"
                     [class.border-benzRed-700]="deviatingDeliveryAdressForm.controls.street_nr.touched && !deviatingDeliveryAdressForm.controls.street_nr.valid"
                     type="text" placeholder="Nr"
                     class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
            </label>
          </app-inputerrors>
          <app-inputerrors [control]="deviatingDeliveryAdressForm.controls.zipcode">
            <label class="flex flex-col gap-1">
              Postleitzahl
              <input formControlName="zipcode"
                     [class.border-benzRed-700]="deviatingDeliveryAdressForm.controls.zipcode.touched && !deviatingDeliveryAdressForm.controls.zipcode.valid"
                     type="text" pattern="[0-9]+" placeholder="PLZ"
                     class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
            </label></app-inputerrors>
          <app-inputerrors [control]="deviatingDeliveryAdressForm.controls.city">
            <label class="flex flex-col gap-1">
              Ort
              <input formControlName="city"
                     [class.border-benzRed-700]="deviatingDeliveryAdressForm.controls.city.touched && !deviatingDeliveryAdressForm.controls.city.valid"
                     type="text" placeholder="Ort"
                     class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
            </label></app-inputerrors>
          <app-inputerrors [control]="deviatingDeliveryAdressForm.controls.country">
            <label class="flex flex-col gap-1">
              Land
              <select formControlName="country"
                      [class.border-benzRed-700]="deviatingDeliveryAdressForm.controls.country.touched && !deviatingDeliveryAdressForm.controls.country.valid"
                      class="bg-white border-[1px] border-benzGrey-900 invalid:font-light invalid:text-benzGrey-600 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3" required>
                <option disabled selected hidden value="">Bitte wählen...</option>
                @for (country of countries; track country.code) {
                  <option [value]="country.code">{{ country.name }}</option>
                }
              </select>
            </label>
          </app-inputerrors>
        </form>
      }
    }
  </div>
  <div class="flex flex-col gap-2 mb-4">
    <label class="flex flex-col gap-1">
      Möchten Sie uns noch etwas mitteilen?
      <input [(ngModel)]="additionalComment"
             type="text" placeholder="(Optional)"
             class="border-[1px] border-benzGrey-900 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3">
    </label>
    <label class="flex flex-col gap-1">
      Wie sind Sie auf uns aufmerksam geworden?
      <select [(ngModel)]="referer" class="bg-white border-[1px] border-benzGrey-900 invalid:font-light invalid:text-benzGrey-600 placeholder:font-light placeholder:text-benzGrey-600 rounded-lg px-2 py-3"
              required>
        <option selected disabled value="">(Optional)</option>
        @for (referrerOption of refererOptions(); track $index) {
          <option value="{{referrerOption.value}}">{{referrerOption.label}}</option>
        }
      </select>
    </label>
    <h2 class="text-2xl leading-snug">Rechtlicher Hinweis</h2>
    <div class="overflow-y-scroll bg-white p-2 border-2 border-benzGrey-900 max-h-[25vH] rounded-lg">
      Die genannten Preise verstehen sich inklusive 19% MwSt. und Bediengeld (BG*) zzgl. optionaler Leistungen (Versand
      / Wertmarken / Wertschecks und Zutrittsbänder).
    </div>
  </div>
  <div class="flex flex-col gap-2 mb-4">
    <div class="overflow-y-scroll bg-white p-2 border-2 border-benzGrey-900 max-h-[25vH] rounded-lg">
      Es wird darauf hingewiesen, dass nach §312g Abs. 2 Nr. 9 BGB kein Widerrufsrecht besteht.<br/>
      Bitte beachten Sie unsere <a href="https://www.beimbenz.de/agb" target="_blank" class="underline">Allgemeinen Geschäftsbedingungen</a> (AGB) und die <a class="underline" target="_blank" href="https://www.beimbenz.de/hausordnung">Hausordnung</a>.
    </div>
    <label class="flex gap-2" [class.text-benzRed-700]="!acceptTermsAndConditions && triedToSubmit">
      <input type="checkbox" [(ngModel)]="acceptTermsAndConditions"
             class="border-[1px] border-benzGrey-900 scale-150 ml-1 accent-benzRed-700">
      Ich erkläre hiermit, dass ich mit den AGB und der Hausordnung einverstanden bin.
    </label>
  </div>
  <button (click)="confirmBooking()" class="px-8 py-4 bg-benzRed-700 text-white rounded-lg">
    Kostenpflichtig reservieren
  </button>
</div>
